import type { SagaIterator } from 'redux-saga';
import { fork, take, call, select, SagaReturnType } from 'redux-saga/effects';
import { getCentrifugoInitialState } from './initialData';
import { getCf } from '../../../../services/centrifugo';
import {
  SET_CENTRIFUGO_CONNECTED,
  SET_CENTRIFUGO_INITIAL_DATA,
} from '../../../constants/centrifugo';
import {
  isLoggedInSelector,
  userNumberSelector,
} from '../../../reducers/app/params';
import { CHANNEL_NAMESPACES } from '../../../../constants/centrifugo';
import { logger } from '../index';

export function* connectorsWatchers(projects: string[]) {
  // running connection for channels that not using initial data
  yield fork(subscribeToInitialDataIndependentChannels);
  // getting initial data
  yield fork(getCentrifugoInitialState, projects);
  yield fork(subscribeToInitialDataDependentChannels);
}

export function* subscribeToInitialDataDependentChannels() {
  const { payload } = yield take(SET_CENTRIFUGO_INITIAL_DATA);
  const { channels } = payload;
  if (!channels?.length) {
    return;
  }
  yield fork(subscribeToChannels, channels);
}

export function* subscribeToInitialDataIndependentChannels(): SagaIterator<void> {
  yield take(SET_CENTRIFUGO_CONNECTED);
  const isLoggedIn: ReturnType<typeof isLoggedInSelector> = yield select(
    isLoggedInSelector
  );
  if (isLoggedIn) {
    const userNumber: ReturnType<typeof userNumberSelector> = yield select(
      userNumberSelector
    );
    const channels = [`${CHANNEL_NAMESPACES.PERSONAL}:#${userNumber}`];

    yield fork(subscribeToChannels, channels);
  }
}

export function* subscribeToChannels(channels: string[] = []) {
  const cf: SagaReturnType<typeof getCf> = yield call(getCf);
  if (!cf) {
    return;
  }
  for (const channel of channels) {
    try {
      // INFO: error will be thrown by newSubscription method instead of "subscribe"
      const sub = cf.newSubscription(channel);
      sub?.on('publication', (payload) => {
        cf.emit('publication', payload);
      });
      sub?.subscribe();
    } catch (e) {
      logger.error('Error while subscribing to channel', e);
    }
  }
}
